<template>
  <el-dialog
    top="25vh"
    width="600px"
    :title="$t('returnGoods.allTitle')"
    append-to-body
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-loading="submitLoading"
    :element-loading-text="$t('returnGoods.loading')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.2)"
    @close="close">
    <section>
      <p class="tips-text" v-if="invoicesItem.marketingQuality == 'Y'">
        {{$t('returnGoods.allVipPayAndOther')}}<span>{{ invoicesItem.otherAmount }}₫</span>
        <a v-if="Number(invoicesItem.couponAmount) > 0">（{{$t('returnGoods.allHasCoupon')}}{{invoicesItem.couponAmount}}₫）</a>，
        {{$t('returnGoods.allVipPay')}}<span>{{ invoicesItem.crmAmount }}₫</span>{{$t('returnGoods.allBackVip')}}。
      </p>
      <p class="tips-text" v-if="invoicesItem.marketingQuality == 'N'">
        {{$t('returnGoods.allVipPayAndOther')}}
        <span>{{ $amount.add(Number(invoicesItem.otherAmount), Number(invoicesItem.crmAmount)) }}₫</span>
      </p>
      <div class="return-reason">
        <p>
          <span>*</span>
          {{$t('returnGoods.returnReason')}}：
        </p>
        <el-input type="textarea" resize="none" rows="5" :placeholder="$t('returnGoods.pleaseInput')" v-model="description"></el-input>
      </div>
      <div class="action-btn row space-end">
        <el-button @click="close">{{$t('returnGoods.allCancel')}}</el-button>
        <el-button type="primary" :loading="submitLoading" @click="sureSubmit">{{$t('returnGoods.allSure')}}</el-button>
      </div>
    </section>
  </el-dialog>
</template>

<script>
import { submitAllRetreatOrder } from '@/libs/http/modules/posOrder'
export default {
  name: 'AllOrdingReturn',
  props: {
    invoicesItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      description: '',
      dialogVisible: true,
      submitLoading: false
    }
  },
  methods: {
    close() {
      this.dialogVisible = false
      this.$emit('close')
    },
    sureSubmit() {
      if (!this.description) {
        return this.$message({ showClose: true, message: this.$t('returnGoods.fillReasonTip'), type: 'error', duration: 2000 })
      }
      this.submitLoading = true
      let reqData = {
        remark: this.description,
        orderId: this.invoicesItem.id,
        orderTypeId: this.invoicesItem.orderTypeId
      }
      const cashierItem = JSON.parse(this.$cache.local.get('cashierDeskItem'))
      if (cashierItem) {
        reqData['terminalId'] = cashierItem.id
      }
      submitAllRetreatOrder(reqData)
        .then(res => {
          this.dialogVisible = false
          this.$emit('refresh')
          this.submitLoading = false
        })
        .catch(error => {
          this.submitLoading = false
          this.$message({ showClose: true, message: error, type: 'error', duration: 2000 })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.tips-text {
  margin-top: -30px;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 26px;
  span {
    color: red;
  }
}
.return-reason {
  p {
    margin-bottom: 5px;
    span {
      color: red;
    }
  }
}
.action-btn {
  margin-top: 40px;
}
</style>
